import { render } from "./Admin.vue?vue&type=template&id=19dd14eb"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=19dd14eb&lang=css"
script.render = render

export default script